import { render, staticRenderFns } from "./Medals.vue?vue&type=template&id=3e93ff56&"
import script from "./Medals.vue?vue&type=script&lang=js&"
export * from "./Medals.vue?vue&type=script&lang=js&"
import style0 from "./Medals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports